import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class RetailerProductsApi extends Api {
  readonly url = "/v3/consumer_retailer_products";

  constructor($axios: Context["$axios"]) {
    super("consumerProductService", $axios);
  }

  async get({ id, includes }: GetRetailerProductParams) {
    return await this.request<OneRetailerProductResponse>({
      method: "GET",
      url: `${this.url}/${id}`,
      params: {
        includes,
      },
    });
  }
}
